import { BrowserRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { StoreProvider } from './stores';
import { StylesProvider } from './styles';
import Pages from './pages';
import { useEffect } from 'react';

dayjs.extend(relativeTime);

function App() {

  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("src", "https://acsbapp.com/apps/app/dist/js/app.js");
    script.setAttribute("async", true);
    script.addEventListener("load", () => {
      window.acsbJS.init({
        statementLink: '',
        footerHtml: '',
        hideMobile: false,
        hideTrigger: false,
        disableBgProcess: false,
        language: 'en',
        position: 'right',
        leadColor: '#146FF8',
        triggerColor: '#146FF8',
        triggerRadius: '50%',
        triggerPositionX: 'right',
        triggerPositionY: 'bottom',
        triggerIcon: 'people',
        triggerSize: 'bottom',
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: 'small',
          triggerPositionX: 'right',
          triggerPositionY: 'bottom',
          triggerOffsetX: 10,
          triggerOffsetY: 10,
          triggerRadius: '20'
        }
      });
    });

    document.body.appendChild(script);
  }, []);

  return (
    <StoreProvider>
      <StylesProvider>
        <BrowserRouter>
          <Pages />
        </BrowserRouter>
      </StylesProvider>
    </StoreProvider>
  );
}

export default App;
